import { replaceAll } from './helpers';

/**
 * Returns a string of the concatenation of tags that start with the string argument
 * @param tags, Type {Tag[]}
 * @param tagType, Type {string}
 */
export function getSubTags(tags: any[], tagType: string): string {
  const result: String[] = [];
  for (const currentTag of tags) {
    if (currentTag.tagName.startsWith(tagType)) {
      result.push(currentTag.displayName);
    }
  }
  return result.sort().join(', ');
}

/**
 * Returns a boolean indicating whether an entity has the passed in tag or not
 * @param tags, Type {Tag[]}
 * @param tag, Type {string}
 */
export function hasTag(tags: any[], tag: string): boolean {
  return tags.some(t => t.tagName === tag);
}

/**
 * Returns an array of strings containing tags that match passed in tag1
 * or tag2 and do not match excludeTag
 * @param tags, Type {any[]}
 * @param tag1, Type {string}
 * @param tag2, Type {string}
 * @param excludeTag, Type {string}
 */
export function loadTags(tags: any[], tag1: string, tag2: string, excludeTag: string): String[] {
  const result: String[] = [];
  for (const currentTag of tags) {
    if (!excludeTag) {
      if (!tag2) {
        if (currentTag.tagName.startsWith(tag1)) {
          result.push(currentTag.displayName);
        }
      } else {
        if (currentTag.tagName.startsWith(tag1) || currentTag.tagName.startsWith(tag2)) {
          result.push(currentTag.displayName);
        }
      }
    } else {
      if (!tag2) {
        if (currentTag.tagName.startsWith(tag1)
          && !currentTag.tagName.startsWith(excludeTag)) {
          result.push(currentTag.displayName);
        }
      } else {
        if ((currentTag.tagName.startsWith(tag1) || currentTag.tagName.startsWith(tag2))
          && !currentTag.tagName.startsWith(excludeTag)) {
          result.push(currentTag.displayName);
        }
      }
    }
  }
  // First, filter out tags that can't be displayed on the front end, i.e. tags with null displayName
  return result.filter(tagName => tagName !== null).sort();
}

/**
 * Returns an array of strings containing tags that match passed in tag, checks for second tag of ::Free
 * Example:
 * Amenities::Internet::Wireless
 * Amenities::Internet::Wireless::Free
 *
 * Will generate a tag of:
 * Wireless (Free)
 *
 * @param tags, Type {any[]}
 * @param tag, Type {string}
 */
export function loadTagsWithFree(tags: any[], tag: string): String[] {
  const result: String[] = [];
  for (const currentTag of tags) {
    if (currentTag.tagName.startsWith(tag) && !currentTag.tagName.endsWith('::Free')) {
      if (tags.some(t => t.tagName === currentTag.tagName + '::Free')) {
        result.push(currentTag.displayName + ' (Free)');
      } else {
        result.push(currentTag.displayName);
      }
    }
  }
  return result.sort();
}

export function getFteAwardTags(tags: any[]) {
  let result = [];
  result = tags.filter(t => t.tagName.includes('Awards::Flight Training::'));
  return result;
}

export function getAwardName(tagName: string): string {
  let awardName = '';
  const re = /Awards::Flight Training::(?<awardName>.+)/;
  const match = tagName.match(re);

  if (match != null && match[1] != null) {
    awardName = match[1];
  }
  return awardName;
}

export function getAwardYear(tagName: string): string {
  const tagNameStripped = getAwardName(tagName);
  let dateRange = '';
  const re = /(?<dateRange>\d{4}-?\d{0,2}) /;
  const match = tagNameStripped.match(re);
  if (match != null && match[1] != null) {
    dateRange = match[1];
    dateRange = dateRange.substr(0, 4);
  }
  return dateRange;
}

export function getBadgeImageUrl(tagName: string): string {
  let tagNameStripped = getAwardName(tagName);
  let dateRange = '';
  const re = /(?<dateRange>\d{4}-?\d{0,2}) /;
  const match = tagNameStripped.match(re);
  if (match != null && match[1] != null) {
    dateRange = match[1];
    if (+dateRange.substr(0, 4) < 2023) {
      // earlier than 2023 we don't have custom badges, so use old generic url
      return 'https://youcanfly.aopa.org/-/media/Images/you-can-fly/awardsLarge.png';
    }
    let url = `https://www.aopa.org/-/media/Images/passport/${dateRange}/FTSurvey/`;

    tagNameStripped = replaceAll(tagNameStripped, '-', '');
    tagNameStripped = replaceAll(tagNameStripped, ' ', '_');
    tagNameStripped = replaceAll(tagNameStripped, '__', '_');
    url = url + tagNameStripped;
    return url;
  }
  // if we cannot match the tag name, we will assume that it is a historical tag and use the generic award image
  return 'https://youcanfly.aopa.org/-/media/Images/you-can-fly/awardsLarge.png';
}


export function getCurrentFteAwardTags(tags: any[]) {
  const current = tags.filter(t => t.isActive);
  return current;
}

export function getHistoricalFteAwardTags(tags: any[]) {
  const historical = tags.filter(t => !t.isActive);
  return historical;
}
